import type { VNode } from "vue";
import Vue from "vue";
import ColumnFilterComponent from "@/components/controls/grid/columnfilters/ColumnFilterComponent.vue";
import type { CreateElement } from "vue/types/vue";
import type {
  FilterFunc,
  FilterState,
  FilterType,
} from "@/components/controls/grid/columnfilters/ColumnFilters";
import { buildApplyFilter } from "@/components/controls/grid/columnfilters/ColumnFilters";
import { LocalDate } from "@js-joda/core";
import BmDate from "@/components/controls/input/BmDate.vue";

function isLocalDate(toTest: any): toTest is LocalDate {
  return (toTest as LocalDate)?.chronology !== undefined;
}

const dateFilterTypes: FilterType[] = [
  {
    type: "filter_equals",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            itemValue.isEqual(LocalDate.parse(filterValue))
        : true;
    },
  },
  {
    type: "filter_not_equals",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            !itemValue.isEqual(LocalDate.parse(filterValue))
        : true;
    },
  },
  {
    type: "filter_after",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            itemValue.isAfter(LocalDate.parse(filterValue))
        : true;
    },
  },
  {
    type: "filter_before",
    values: 1,
    applyFunc: (itemValue: any, formattedItemValue: any, filterValue: any) => {
      return filterValue
        ? isLocalDate(itemValue) &&
            itemValue.isBefore(LocalDate.parse(filterValue))
        : true;
    },
  },
];

function createControlSlot(createElement: CreateElement): any {
  return function (props: any) {
    return createElement(BmDate, {
      props: {
        clearable: true,
        value: props.value ? LocalDate.parse(props.value) : null,
      },
      on: {
        input: function (event: LocalDate) {
          props.setValue(event?.toString() ?? ""); // ISO-8601
        },
      },
    });
  };
}

export function buildApplyDateFilter(state: FilterState): FilterFunc {
  return buildApplyFilter(state, dateFilterTypes);
}

export default Vue.extend({
  name: "DateFilterComponent",
  components: { ColumnFilterComponent },
  render(createElement: CreateElement): VNode {
    return createElement(ColumnFilterComponent, {
      attrs: { ...this.$attrs },
      props: { filterTypes: dateFilterTypes },
      scopedSlots: {
        control1: function (props: any) {
          return createElement(BmDate, {
            props: {
              clearable: true,
              value: props.value ? LocalDate.parse(props.value) : null,
            },
            on: {
              input: function (event: LocalDate) {
                props.setValue(event?.toString() ?? ""); // ISO-8601
              },
            },
          });
        },
        control2: function (props: any) {
          return createElement(BmDate, {
            props: {
              clearable: true,
              value: props.value ? LocalDate.parse(props.value) : null,
            },
            on: {
              input: function (event: LocalDate) {
                props.setValue(event?.toString() ?? ""); // ISO-8601
              },
            },
          });
        },
      },
    });
  },
});
